// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M1.86.77A2.212 2.212 0 0 0 .038 2.52C.003 2.704 0 3.627.006 12.084l.006 9.36.056.192c.135.466.427.894.804 1.18.195.146.53.307.784.374l.204.054h12.768l.216-.057a2.21 2.21 0 0 0 1.614-1.676c.038-.171.042-.4.042-2.683v-2.496l-.063-.132c-.233-.49-.882-.602-1.234-.212a1.01 1.01 0 0 0-.14.21c-.05.11-.051.12-.063 2.572l-.012 2.461-.072.142a.694.694 0 0 1-.41.345c-.073.018-1.944.026-6.272.026-6.1 0-6.17 0-6.296-.048a.734.734 0 0 1-.376-.36c-.049-.108-.049-.112-.05-9.336V2.772l.057-.12a.845.845 0 0 1 .163-.219c.212-.194-.407-.178 6.56-.171l6.216.006.117.06c.147.075.265.21.327.377.047.126.048.184.048 2.527 0 2.353 0 2.4.049 2.529.065.174.21.333.378.415a.574.574 0 0 0 .317.067c.309-.001.56-.161.693-.443l.063-.132V5.172c0-2.284-.004-2.512-.042-2.683a2.229 2.229 0 0 0-.815-1.29 2.42 2.42 0 0 0-.787-.386l-.204-.057L8.328.753C4.838.75 1.939.759 1.86.77m17.385 6.774a.819.819 0 0 0-.433.412.645.645 0 0 0-.053.3c0 .325-.045.27 1.39 1.705l1.283 1.283-7.074.012-7.074.012-.122.064a.85.85 0 0 0-.354.377.804.804 0 0 0 .012.603.726.726 0 0 0 .575.43c.103.018 2.43.026 7.088.026h6.936l-1.276 1.278c-.984.985-1.288 1.303-1.324 1.386-.303.688.47 1.36 1.088.947.192-.128 3.957-3.913 4.023-4.043a.854.854 0 0 0 .022-.612c-.052-.139-.125-.216-2.013-2.103-1.316-1.316-1.998-1.982-2.077-2.027-.1-.057-.15-.069-.324-.075a.876.876 0 0 0-.293.025"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const LogoutIcon = Icon;
export default LogoutIcon;
